import React from 'react';
import { Money } from 'shared/types/product/Money';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import useLocale from 'helpers/hooks/useLocale';
import { getCurrencyCookie } from 'helpers/utils/getCurrencyCookie';

interface Props {
  discountedPrice?: Money;
  prices?: any;
  className?: string;
}

const Price: React.FC<Props> = ({ prices, discountedPrice, className = '' }) => {
  const { ctLocale: locale } = useLocale();
  if (prices === undefined) return;
  const localeSelection = getCurrencyCookie('locale_selection');
  const currency: string = localeSelection?.currency || null;
  return (
    <>
      {discountedPrice ? (
        <div className="flex gap-x-2 sm:flex-col sm:gap-y-2">
          <p className="font-body text-14 font-normal leading-[14px] text-[#4B4B4B] line-through">
            RRP {CurrencyHelpers.formatForCurrency(discountedPrice, locale)}
          </p>
          {/* <p className="font-body text-16 font-bold leading-4 text-[#E30616]">
            Now {CurrencyHelpers.formatForCurrency(price ?? '', locale)}
          </p> */}
        </div>
      ) : (
        <p className={`font-body text-[28px] font-bold leading-8 text-primary-black sm:text-[32px] ${className}`}>
          {/* Need to Fix */}
          {/* {CurrencyHelpers.formatForCurrency(price ?? '', locale)} */}
          {currency === 'GBP' ? '£' : '€'}
          {currency === 'GBP' ? (prices?.[0]?.priceGB / 100).toFixed(2) : (prices?.[0]?.priceEU / 100).toFixed(2)}
        </p>
      )}
    </>
  );
};

export default Price;
